module.exports = __webpack_public_path__ + "static/media/1.2ca5ae50.gif";